module.exports = __webpack_public_path__ + "static/media/logo.aa5c5161.svg";